<template>
  <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px">
      <el-form-item label="关账开始日期" prop="closeBookBeginDate">
        <el-date-picker
            v-model="form.closeBookBeginDate"
            type="date"
            placeholder="请选择关账开始日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            required/>
      </el-form-item>
      <el-form-item label="关账结束日期" prop="closeBookEndDate">
        <el-date-picker
            v-model="form.closeBookEndDate"
            type="date"
            placeholder="请选择关账结束日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            required/>
      </el-form-item>
      <el-form-item label="记账日期" prop="chooseBookDate">
        <el-date-picker
            v-model="form.chooseBookDate"
            type="date"
            placeholder="请选择记账日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            required/>
      </el-form-item>
      <el-form-item label="管控类型" prop="bookType">
        <el-select
            v-model="form.bookType"
            placeholder="请选择管控类型"
            style="width: 100%"
            required>
          <el-option label="非签收" :value="0"/>
          <el-option label="签收" :value="1"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="resetForm">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submitForm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "CloseBookDateEdit",
    data() {
      return {
        dialogVisible: false,
        title: "",
        form: {
          pkId: "",
          closeBookBeginDate: "",
          closeBookEndDate: "",
          chooseBookDate: "",
          bookType: "",
        },
        rules: {
          closeBookBeginDate: [{required: true, message: "请选择关账开始日期", trigger: "blur"}],
          closeBookEndDate: [{required: true, message: "请选择关账结束日期", trigger: "blur"}],
          chooseBookDate: [{required: true, message: "请选择记账日期", trigger: "blur"}],
          bookType: [{required: true, message: "请选择管控类型", trigger: "blur"}],
        },
        loading: false,
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row && row.pkId) {
          this.title = "编辑月结时间";
          this.form = Object.assign({}, row);
        } else {
          this.title = "新增月结时间";
        }
      },

      resetForm() {
        this.dialogVisible = false;
        this.form.bookType = "";
        this.form.closeBookBeginDate = "";
        this.form.closeBookEndDate = "";
        this.form.chooseBookDate = "";
      },

      submitForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$http.save("basic", "closeBooKDates", this.form).then(res => {
              this.loading = false;
              if (res.success) {
                this.$message.success("保存成功");
                this.resetForm();
                this.$emit("save-success");
              }
            }).catch(() => {
              this.loading = false;
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>